let AriaRole = /*#__PURE__*/function (AriaRole) {
  AriaRole["Dialog"] = "dialog";
  AriaRole["Group"] = "group";
  AriaRole["Link"] = "link";
  AriaRole["List"] = "list";
  AriaRole["MenuBar"] = "menubar";
  AriaRole["MenuItem"] = "menuitem";
  AriaRole["MenuItemRadio"] = "menuitemradio";
  AriaRole["Presentation"] = "presentation";
  AriaRole["Tab"] = "tab";
  AriaRole["TabList"] = "tablist";
  AriaRole["TabPanel"] = "tabpanel";
  return AriaRole;
}({});
let CssCursor = /*#__PURE__*/function (CssCursor) {
  CssCursor["Default"] = "";
  CssCursor["Grab"] = "grab";
  CssCursor["Grabbing"] = "grabbing";
  CssCursor["NoDrop"] = "no-drop";
  CssCursor["NotAllowed"] = "not-allowed";
  return CssCursor;
}({});
let EditableTarget = /*#__PURE__*/function (EditableTarget) {
  EditableTarget["Input"] = "INPUT";
  EditableTarget["Textarea"] = "TEXTAREA";
  EditableTarget["Select"] = "SELECT";
  EditableTarget["ContentEditable"] = "contenteditable";
  return EditableTarget;
}({});
let HtmlTag = /*#__PURE__*/function (HtmlTag) {
  HtmlTag["Default"] = "div";
  HtmlTag["Button"] = "button";
  HtmlTag["Label"] = "label";
  HtmlTag["Link"] = "a";
  HtmlTag["Paragraph"] = "p";
  return HtmlTag;
}({});
let IframeScrollingValue = /*#__PURE__*/function (IframeScrollingValue) {
  IframeScrollingValue["Default"] = "auto";
  IframeScrollingValue["Yes"] = "yes";
  IframeScrollingValue["No"] = "no";
  return IframeScrollingValue;
}({});
let Tone = /*#__PURE__*/function (Tone) {
  Tone["Magic"] = "magic";
  return Tone;
}({});

export { AriaRole, CssCursor, EditableTarget, HtmlTag, IframeScrollingValue, Tone };
